export default {"src":"/_next/static/media/square.e55f9d91.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};